export default {
  pages: {
    deliveriesShow: {
      title: 'Yetkazma #{id}',
    },
  },
};
